module.exports = __webpack_public_path__ + "static/media/ElSalvador.601f91ac.jpg";